import { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import './resort-pricing.sass'
import { FormattedMessage, injectIntl, intlShape } from 'react-intl'
import ReactTooltip from 'react-tooltip'
import moment from 'moment'
import get from 'lodash/get'
import map from 'lodash/map'
import minBy from 'lodash/minBy'
import each from 'lodash/each'
import sortBy from 'lodash/sortBy'
import maxBy from 'lodash/maxBy'
import groupBy from 'lodash/groupBy'
import isEmpty from 'lodash/isEmpty'
import filter from 'lodash/filter'
import isObject from 'lodash/isObject'
import store from 'store2'
import TravelDatepicker from '../helpers/TravelDatepicker'
import ResortPricingRow from './ResortPricingRow'
import API from '../../api'
import GuestPicker from '../forms/GuestPicker'
import PlaceholderResortPricing from './PlaceholderResortPricing'
import ResortPricingRowUnavailable from './ResortPricingRowUnavailable'
import ResortPricingRowNoGuestsOrDate from './ResortPricingRowNoGuestsOrDate'
import ResortPricingRowSoldOut from './ResortPricingRowSoldOut'
import AvailabilityCalendar from './AvailabilityCalendar'
import RoomPopup from '../popups/RoomPopup'
import InclusionDescriptionPopup from '../popups/InclusionDescriptionPopup'
import MealPlanPopup from '../popups/MealPlanPopup'
import { setDepartureDate, setGuests, setDives } from '../../actions/dive-operator-actions'
import { createUrl } from '../../localized-urls'
import { parseQuery } from '../../utils'
import ResortInclusions from '../popups/ResortInclusions'
import { trackEcommerce } from '../../gtm'
import { convertCurrency } from '../helpers/PriceConverter'

export const prepareGuestSplitting = (guests = []) => {
  let preparedSplitting = []
  guests && guests.forEach(item => {
    preparedSplitting.push(JSON.stringify(item))
  })
  return preparedSplitting
}

class ResortPricing extends Component {
  constructor(props) {
    super(props)
    const query = parseQuery()
    const roomParams = store.get('roomParams') || {}
    const dates = store.get('date')
    this.state = {
      loading: true,
      roomPopupIsOpen: false,
      showCalendar: false,
      mealPlans: {},
      filters: {
        date_0: query && query.date_from ? query.date_from : ((dates && dates[0]) || undefined),
        date_1: query && query.date_from && query.duration ? moment(query.date_from).add(query.duration, 'd').format('YYYY-MM-DD') : ((dates && dates[1]) || undefined),
        nights: query && query.duration ? query.duration : (store.get('duration') || undefined),
        guests_split: prepareGuestSplitting(get(roomParams, 'guest_split', get(roomParams, 'details', [roomParams]))),
      },
      selectedGuests: roomParams,
      totalGuests: roomParams.totalGuests || roomParams.students + roomParams.divers + roomParams.nonDivers,
      rooms: [],
    }
  }

  componentDidMount() {
    this.getPrices()
  }

  getPrices = () => {
    this.setState({
      loading: true,
    })
    store('duration', this.state.filters.nights)
    if(this.state.filters.date_0 && this.state.filters.date_1) {
      store('date', [this.state.filters.date_0, this.state.filters.date_1])
    } else {
      store.remove('date')
    }

    this.props.dispatch(setDepartureDate({
      dateFrom: this.state.filters.date_0,
      dateTo: this.state.filters.date_1,
      duration: this.state.filters.nights,
    }))
    this.props.dispatch(setGuests(this.state.selectedGuests))

    API(`booking/resort/${this.props.slug}/meal-plans/`).get()
      .then((mealPlans) => {
        this.setState({
          mealPlans: mealPlans.mealPlanDescriptions,
        })
      })

    if(this.props.includeFreeDiveInsurance) {
      API('booking/insurances/').get().then((insurance) => {
        this.setState({
          insurance,
        })
      })
    }

    API(`booking/resort/${this.props.slug}/rooms/`).get(
      this.state.filters
    ).then((rooms) => {
      let gtmProducts = []
      let isDivesSet = false
      rooms.forEach((room) => {
        if(this.props.isFixedPackage) {
          let packages = map(room.packages, function(pack, key) {
            if(isObject(pack)) {
              pack.mealPlan = +key
              pack.ratePrice = pack.price
              if(!room.showRates && pack.ids && pack.ids.length && !pack.exceptions.length) {
                room.showRates = true
              }

              if(pack.exceptions && pack.exceptions.length) {
                room.exceptionMessage = pack.exceptions[0]
              }

              if(pack.mealPlan && pack.ratePrice && !pack.exceptions.length) {
                pack.id = key
                return pack
              }
            }
          })
          packages = filter(packages, function(pack) { return pack })

          room.rates = packages
          room.packageDiveKind = get(room.rates, '[0].packageDiveKind') // remove this line when BE will send it in a normal way
          room.divesAmount = room.packages.dives

          if(room.divesAmount && !isDivesSet) {
            this.props.dispatch(setDives({ divesAmount: room.divesAmount, diveKind: room.packageDiveKind }))
            isDivesSet = true
          }

          room.diveCenterInclusions = room.packages.diverInclusions
          room.resortRoomInclusions = room.packages.nondiverInclusions
        } else {
          room.groupedRates = groupBy(room.rates, 'mealPlan')
          room.rates = []
          each(room.groupedRates, function(v) {
            let minPrice = minBy(v, 'ratePrice')
            let maxComparePrice = maxBy(v, 'compareRatePrice')
            if(maxComparePrice) {
              minPrice.compareRatePrice = maxComparePrice.compareRatePrice
            }
            if(get(v, '[0].error[0]')) {
              room.error = v[0].error[0]
            }
            room.rates.push(minPrice || v[0])
          })
          room.rates = sortBy(room.rates, 'ratePrice')
        }

        if(room.error.length) {
          room.showRates = false
          room.rates = null
        }

        each(room.rates, (rate) => {
          gtmProducts.push({
            variant: room.title,
            id: this.props.id,
            price: Math.round(convertCurrency(rate.ratePrice, room.currency)),
            name: this.props.title,
            category: 'Dive Resort',
            quantity: 1,
          })
        })

        if(room.rates && room.rates.length) {
          room.minimalPrice = room.rates[0].ratePrice
        }
      })

      trackEcommerce('product_view', {
        actionField: {
          list: 'Resort product',
        },
        products: gtmProducts,
      })

      this.setState({
        loading: false,
        rooms: sortBy(rooms, 'minimalPrice'),
      }, () => {
        ReactTooltip.rebuild()
      })
    })
  }

  handleDatesChange = (dates) => {
    this.setState({
      filters: {
        ...this.state.filters,
        nights: dates.duration,
        date_0: dates.dateFrom || undefined,
        date_1: dates.dateTo || undefined,
      },
    }, () => {
      this.getPrices()
      if(isEmpty(this.state.selectedGuests)) {
        document.querySelector('.rooms-and-guest-selector').click()
      }
    })
  }

  handleGuestsChange = (guests) => {
    this.setState({
      filters: {
        ...this.state.filters,
        guests_split: prepareGuestSplitting(guests.guests_split),
      },
      selectedGuests: guests,
      totalGuests: guests.totalGuests,
    }, () => {
      this.getPrices()
      if(!this.state.filters.date_0 || !this.state.filters.date_1) {
        document.querySelector('.travel-datepicker').click()
      }
    })
  }

  updateDate = (type = 'subtract') => {
    this.setState({
      filters: {
        ...this.state.filters,
        date_0: moment(this.state.filters.date_0)[type](1, 'd').format('YYYY-MM-DD'),
        date_1: moment(this.state.filters.date_1)[type](1, 'd').format('YYYY-MM-DD'),
      },
    }, this.getPrices)
  }

  openRoomPopup = (roomInfo) => {
    this.setState({
      roomInfo,
      roomPopupIsOpen: true,
    })
  }

  closeRoomPopup = () => {
    this.setState({
      roomPopupIsOpen: false,
    })
  }

  triggerModal = (type, isOpen) => {
    this.setState({
      [type]: isOpen,
    })
  }

  setPopupData = (type, data) => {
    this.setState({
      [type]: true,
      ...data,
    })
  }

  triggerAvailabilityCalendar = (value) => {
    this.setState({
      showCalendar: value,
    }, () => {
      console.log('clicked', this.state.showCalendar)
    })
  }

  checkStudentsPackages() {
    const { hasStudentCourses, availablePackageKinds, isFixedPackage } = this.props

    if(!hasStudentCourses) {
      return false
    }
    // 40 - kind for students
    if(isFixedPackage && availablePackageKinds.indexOf(40) === -1) {
      return false
    }

    return true
  }

  render() {
    return (<div className='resort-pricing'>
      <ReactTooltip effect='solid' />
      <ResortInclusions />
      <div className='resort-pricing__header'>
        <div className='header-row'>
          <div className='back-section'>
            <a className='font-icons left-arrow-icon' href={createUrl('search_dr', { slug: this.props.countrySlug })} />
            <span className='title'>{ this.props.title }</span>
            <div className='details'>
              <FormattedMessage id='see_more_in_location'
                values={{
                  location: this.props.countryTitleIn,
                }}
                defaultMessage='See more {location}' />
            </div>
          </div>
          <div className='filters-wrapper'>
            <div className='field-wrapper'>
              <GuestPicker
                noStudentsPackages={!this.checkStudentsPackages()}
                onSelect={this.handleGuestsChange}
                showIcon
                selectedGuests={this.state.selectedGuests} />
            </div>
            <div className='field-wrapper'>
              <i className='font-icons calendar-icon' />
              <TravelDatepicker
                callback={this.handleDatesChange}
                shopId={this.props.id}
                shopSlug={this.props.slug}
                showLegend
                className='travel-datepicker'
                isFixedPackage={this.props.isFixedPackage}
                guestsSplit={this.state.filters.guests_split}
                minDuration={this.props.minimalNumberOfNights}
                maxDuration={21}
                range
                datesInOneField
                minDurationForStudents={5}
                validateStudentsPackage
                students={this.state.selectedGuests.students}
                dateFrom={this.state.filters.date_0}
                dateTo={this.state.filters.date_1}
                updateDuration
                placeholder={<FormattedMessage id='date' defaultMessage='Date' />} />
            </div>
            <button className='search-btn' onClick={this.getPrices}>
              <i className='font-icons find-icon' />
            </button>
          </div>
        </div>
        <div className='header-row'>
          <div className='resort-pricing__rooms header-title'><FormattedMessage id='rooms' defaultMessage='Rooms' /></div>
          <div className='resort-pricing__whats-included header-title'><FormattedMessage id='whats_included' defaultMessage='What’s included' /></div>
          <div className='resort-pricing__meal-plan header-title'><FormattedMessage id='meal_plan' defaultMessage='Meal plan' /></div>
          <div className='resort-pricing__price header-title'><FormattedMessage id='today_price' defaultMessage='Today’s price' /></div>
        </div>
      </div>
      { !this.props.isFixedPackage && this.state.filters.date_0 && this.state.filters.date_1 ? (
        <AvailabilityCalendar
          showCalendar={this.state.showCalendar}
          shopSlug={this.props.slug}
          duration={this.state.filters.nights || 7}
          guestsSplit={this.state.filters.guests_split}
          triggerAvailabilityCalendar={this.triggerAvailabilityCalendar}
          dateFrom={this.state.filters.date_0}
          updateDate={this.updateDate}
          dateTo={this.state.filters.date_1} />) : '' }
      <InclusionDescriptionPopup
        activity={this.state.activity}
        thumbnails={this.state.thumbnails}
        activityTitle={this.state.activityTitle}
        isOpen={this.state.isOpenInclusionDescriptionPopup}
        closeModal={() => this.triggerModal('isOpenInclusionDescriptionPopup', false)} />
      <MealPlanPopup
        mealPlan={this.state.mealPlan}
        iconClass={this.state.iconClass}
        description={this.state.mealPlanDescription}
        isOpen={this.state.isOpenMealPlanPopup}
        closeModal={() => this.triggerModal('isOpenMealPlanPopup', false)} />
      { this.state.roomInfo
        ? <RoomPopup isOpen={this.state.roomPopupIsOpen} roomInfo={this.state.roomInfo} closeModal={this.closeRoomPopup} areaFormat={this.props.areaFormat} />
        : '' }
      <div className='resort-pricing__body'>
        { this.state.loading ? (
          <Fragment>
            {
              [...new Array(4)].map((_, i) => {
                return (<PlaceholderResortPricing key={i} />)
              })
            }
          </Fragment>
        )
          : this.state.rooms.map(room => {
            if(!this.state.totalGuests || !this.state.filters.date_0 || !this.state.filters.date_1) {
              return <ResortPricingRowNoGuestsOrDate
                handleGuestsChange={this.handleGuestsChange}
                room={room}
                students={this.state.selectedGuests.students}
                {...this.state.filters}
                {...this.props}
                handleDatesChange={this.handleDatesChange}
                noGuests={!this.state.totalGuests}
                openRoomPopup={this.openRoomPopup}
                key={room.id}
              />
            } else if(!room.showRates && (!room.rates || !room.rates.length)) {
              return <ResortPricingRowUnavailable
                room={room}
                openRoomPopup={this.openRoomPopup}
                areaFormat={this.props.areaFormat}
                key={room.id}
              />
            } else if(!room.showRates && room.rates) {
              return <ResortPricingRowSoldOut
                room={room}
                areaFormat={this.props.areaFormat}
                openRoomPopup={this.openRoomPopup}
                triggerAvailabilityCalendar={this.triggerAvailabilityCalendar}
                isFixedPackage={this.props.isFixedPackage}
                key={room.id}
              />
            }
            return (<ResortPricingRow
              room={room}
              filters={this.state.filters}
              openRoomPopup={this.openRoomPopup}
              roomParams={this.state.selectedGuests}
              nights={this.state.filters.nights}
              key={room.id}
              areaFormat={this.props.areaFormat}
              mealPlans={this.state.mealPlans}
              insurance={this.state.insurance && this.state.insurance[0]}
              slug={this.props.slug}
              setPopupData={this.setPopupData}
              countrySlug={this.props.countrySlug}
              isFixedPackage={this.props.isFixedPackage}
            />)
          })
        }
      </div>
    </div>)
  }
}

ResortPricing.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(connect(
  state => ({
    date: state.departureDate,
  })
)(ResortPricing))
